// @flow

import React from 'react';
import SearchContext from '../../utils/searchContext';

const ResultsListContainer = ({ resultItemContainer }) => {
  const ResultItemContainer = resultItemContainer;

  return (
    <SearchContext.Consumer>
      {({ translations, results }) => {
        return (
          <div className="search-results-list">
            {results.length ? (
              results.map((result, index) => (
                <ResultItemContainer
                  key={index}
                  result={result}
                  translations={translations}
                />
              ))
            ) : (
              <p className="no-results">
                {translations
                  ? translations.no_results_label
                  : 'No results found for these filters.'}
              </p>
            )}
          </div>
        );
      }}
    </SearchContext.Consumer>
  );
};

export default ResultsListContainer;
